<app-global-data (OnCountryListReady)="OnCountryList($event)"></app-global-data>

<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

  <c-modal [visible]="showInvitationdata" alignment="center" [backdrop]="'static'">
  <c-modal-header>
    <h5 cModalTitle>Single Invitation Code</h5>
    <button (click)="closeReasonModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <div class="qrcss">
      <div class="row border-box" *ngFor="let value of InvitationValue">
        <div class="col-md-12">
          <div class="imgcss">
            <img src="{{'data:image/png;base64,'+value?.base64QRCode}}" alt="img" />
          </div>
        </div>
        <!-- <div class="col-md-9"> <label> Tag Name:{{value?.tagName}}</label>
          <div><label>QR Code:{{value?.code}}</label></div>
        </div>
        <div class="col-md-3">
          <div class="imgcss">
            <img src="{{'data:image/png;base64,'+value?.base64QRCode}}" alt="img" />
          </div>
        </div> -->
        <!-- <div class="col-md-12">  <div class="link-css">{{value?.link}}</div> </div> -->
      </div>
    </div>
  </c-modal-body>
  <!-- <c-modal-footer>
    <button cButton color="secondary" (click)="closeReasonModal()">
      Close
    </button>
  </c-modal-footer> -->
</c-modal>

<c-modal [visible]="showInvitationdataMultiple" alignment="center" [backdrop]="'static'">
  <c-modal-header>
    <h5 cModalTitle>Invitation Created Successfully!</h5>
    <div class="modal-header-buttons">
      <button *ngIf="isQrCodeInvite" (click)="printModalContent()" class="print-button" cButton>Print</button> <!-- Print Button -->      
      <button (click)="closeReasonModal()" cButtonClose></button> <!-- Close Button -->
    </div>
  </c-modal-header>
  <c-modal-body>
    <div class="qrcss">
      <div class="row border-box" *ngFor="let value of InvitationValue">
        <div class="col-md-9">  
          <div><label>Invitation Code:{{value?.code}}</label></div>
        </div>
        <div class="col-md-3" id="qrCodePlace" name="qrCodePlace" *ngIf="isQrCodeInvite">
          <div class="imgcss">
            <img src="{{'data:image/png;base64,'+value?.base64QRCode}}" alt="img" />
          </div>
        </div>
        <div class="col-md-12">  <div class="link-css">{{value?.link}}</div> </div>
      </div>
    </div>
  </c-modal-body>
  <!-- <c-modal-footer>
    <button cButton color="secondary" (click)="closeReasonModal()">
      Close
    </button>
  </c-modal-footer> -->
</c-modal>
<div>
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      Create Invitation
      <button [cNavbarToggler]="toolbarCollapseRef"></button>
      <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
        <c-navbar-nav class="me-auto mb-2 mb-lg-0">

        </c-navbar-nav>

        <!-- <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton><svg cIcon
              name="cilChevronDoubleLeft"></svg></button> -->
        <button cTooltip="Save Customer" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="submit()"><svg
            cIcon name="cilSave"></svg></button>

      </div>
    </c-container>
  </c-navbar>
  <c-navbar expand="lg">
    <c-container fluid>
      <div class="container form-css">
        <form cForm [formGroup]="invitationForm">

          <div class="row">
            <!--div class="col-md-4">
              <label cLabel for="tag">Invitation Option
                <span *ngIf="isSingleDetailedInvitation" class="text-danger">*</span>
              </label>
              <div class="table-view">
                <select [valid]="SingleDetailedInvitation" cSelect class="multiple"
                  cFormControl name="isSingleDetailedInvitation"
                  formControlName="isSingleDetailedInvitation">
                  <option selected value="null">Select Invitation</option>
                  <option value="true">Single</option>
                  <!-- <option value="false">Multiple</option>-->
                 <!--
                </select>
                <c-form-feedback
                  [valid]="isSingleDetailedInvitationValid() === ''?true:false">{{isSingleDetailedInvitationValid()}}</c-form-feedback>
              </div>
            </div>-->
            <div class="col-md-6">
              <label cLabel for="isInvitationChannel">QR Delivery Channel
                <span *ngIf="isInvitationChannel" class="text-danger">*</span>
              </label>
              
              <div class="table-view">
                <select [valid]="invitationChannel" cSelect class="Single" cFormControl name="isInvitationChannel" 
                formControlName="isInvitationChannel" (ngModelChange)="InvitationChannelEvent($event)">
                <option selected value="null">Select QR Delivery Channel</option>
                <option value="email">Email</option>
                <!-- <option value="sms">SMS</option>                 -->
                <option value="qrCode">Print</option>
              </select>
              <c-form-feedback
                  [valid]="isinvitationChannelValid() === ''?true:false">{{isinvitationChannelValid()}}</c-form-feedback>
              </div>
            </div>
            <!-- <div class="col-md-4">
              <label cLabel for="tag">Tag</label>
              <div class="table-view">
                <input [valid]="tagValid" cFormControl id="tag" type="email" formControlName="tag" />
                <c-form-feedback [valid]="istagValid() === null?true:false">{{istagValid()}}</c-form-feedback>
              </div>
            </div> -->
            <div class="col-md-4" *ngIf="numberInvitations">
              <label cLabel for="tag">Invitation number</label>
              <div class="table-view">

                <!-- <select  cSelect class="multiple"
                 cFormControl name="numberOfInvitations"
                formControlName="numberOfInvitations">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
              </select> -->
                <input  cFormControl id="numberOfInvitations" type="number"
                  formControlName="numberOfInvitations" />

              </div>
            </div>
            <!-- <div class="col-md-4">
            <label cLabel for="tag"></label>
            <div class="table-view">
            <button cButton type="submit">
              Submit
            </button>
            </div>
          </div> -->
          </div>
        </form>
      </div>
    </c-container>
  </c-navbar>
</div>
<div class="save-model" *ngIf="hideForm">
  <div class="main-height">

    <div class="row g-2 pt-4">
      <div class="container form-css">
        <form [formGroup]="invitationForm" class="needs-validation" cForm>
          <div class="row">
            <div class="col-md-6">
              <label cLabel for="inputEmail">Email Id
                <span *ngIf="emailId" class="text-danger">*</span>
              </label>
              <div class="table-view">
                <input [valid]="emailIdValid" cFormControl id="inputEmail" type="email" formControlName="emailId"/>
                <c-form-feedback
                  [valid]="isCustomerEmailValid() === null?true:false">{{isCustomerEmailValid()}}</c-form-feedback>

              </div>
            </div>
            <div class="col-md-6">
              <label cLabel for="inputEmail">Customer Type</label>
              <div class="table-view">
                <select cSelect id="UseridType" name="Type" > 
                  <option value="Professional">Professional</option>  
                  <option value="Retail">Retail</option>                                  
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <label cLabel for="inputName">Name</label>
              <div class="table-view">
                <input [valid]="nameValid" cFormControl id="inputName" type="text" formControlName="name" />
                <c-form-feedback
                [valid]="isCustomerNameValid() === null?true:false">{{isCustomerNameValid()}}</c-form-feedback>
              </div>
            </div>

            <div class="col-md-7">
              <label cLabel for="mobileNumber">Mobile Number</label>
              <div class="d-flex align-items-center gap-2 table-view">
             
                <select formControlName="dialCode" class="form-select" cSelect style="max-width: 300px;">
                  <option selected value="" >-- Select Code --</option>
                  <option *ngFor="let country of countryList?.dhabiCountries" [value]="country.dialCode">
                    {{ country.countryName }} +{{ country.dialCode }}
                  </option>
                </select>
             
                <input cFormControl id="mobileNumber" type="text" formControlName="mobileNumber" 
                placeholder="Enter number" 
                class="form-control"
                (keypress)="allowOnlyNumbers($event)"
                 />
              </div>
            </div>
          </div>


          <div class="row">

            <div class="col-md-4">
              <label cLabel for="inputDateOfBirth">Date Of Birth</label>
              <div class="table-view">
                <c-date-picker [valid]="dateOfBirthvValid" [inputReadOnly]="true" id="inputDateOfBirth"
                  [maxDate]="minDateOfBirth" closeOnSelect cFormControl id="inputDateOfBirth"
                  formControlName="dateOfBirth" />

              </div>
            </div>

            <div class="col-md-4">
              <label cLabel for="idType">Id Type</label>
              <div class="table-view">
                <select (ngModelChange)="changeId($event)" [valid]="idTypeValid" cSelect id="idType" name="idType" formControlName="idType">
                  <option value="Emirates ID">Emirates ID</option>
                  <option value="Passport">Passport</option>
                  <option value="NA">Not Available</option>
                </select>

              </div>
            </div>
            <div class="col-md-4" *ngIf="view">
              <label cLabel for="idNumber">ID Number</label>
              <div class="table-view">
                <input cFormControl id="idNumber" type="text" formControlName="idNumber" />
              </div>
            </div>
            <div class="col-md-4">
              <label cLabel for="inputRole">Gender</label>
              <div class="table-view">
                <select [valid]="genderIdValid" cSelect id="inputRole" name="inputRole" formControlName="genderId">
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>


              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label cLabel for="addressLine1">Address Line1</label>
              <div class="table-view">

                <input [valid]="addressLine1Valid" cFormControl id="addressLine1" type="text"
                  formControlName="addressLine1" />

              </div>
            </div>

            <div class="col-md-6">
              <label cLabel for="addressLine2">Address Line2</label>
              <div class="table-view">

                <input [valid]="addressLine2Valid" cFormControl id="addressLine2" type="text"
                  formControlName="addressLine2" />

              </div>
            </div>
          </div>
          <div class="row">
            
            <div class="col-md-4">
              <label cLabel for="countryId">Country</label>
              <div class="table-view">
                <select [valid]="countryIdValid" cSelect id="countryId" name="countryId" formControlName="countryId">
                  <option *ngFor="let country of countryList?.dhabiCountries" id="countryList" [value]="country.id">                   
                    {{country.countryName}}</option>
                </select>

              </div>
            </div>
            <div class="col-md-4">
              <label cLabel for="city">City</label>
              <div class="table-view">

                <input [valid]="cityValid" cFormControl id="city" type="text" formControlName="city" />

              </div>
            </div>
            <div class="col-md-4">
              <label cLabel for="state">State</label>
              <div class="table-view">
                <input [valid]="stateValid" cFormControl id="state" type="text" formControlName="state" />

              </div>
            </div>
            <div class="col-md-4">
              <label cLabel for="postalCode">Postal Code</label>
              <div class="table-view">
                <input [valid]="postalCodeValid" cFormControl id="postalCode" type="text"
                  formControlName="postalCode" />

              </div>
            </div>
            <div class="col-md-4">
              <label cLabel for="sourceOfIncome">Source Of Income</label>
              <div class="table-view">
                <select cSelect id="sourceOfIncome" name="sourceOfIncome" formControlName="sourceOfIncome" 
                (change)="onIncomeSourceChange($event)">
                  <option *ngFor="let Parameter of IncomeSourcesValue" [value]="Parameter.value">
                    {{Parameter.value}}</option>
                </select>
              </div>
            </div>
            
            <div *ngIf="showOtherIncomeSource" class="col-md-4">
              <label cLabel for="otherSourceOfIncome">Please specify other source</label>
              <div class="table-view">
                <input type="text" cFormControl id="otherSourceOfIncome" formControlName="otherSourceOfIncome" />
              </div>
            </div>

            <div class="col-md-4">
              <label cLabel for="incomeRange">Income Range</label>
              <div class="table-view">
                <select cSelect id="incomeRange" name="incomeRange" formControlName="incomeRange">
                  <option *ngFor="let Parameter of DecisionParametersSources" [value]="Parameter.value">
                    {{Parameter.value}}</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>



    </div>
  </div>
</div>